<template>
    <CmsLink
        v-if="preHeader && preHeader.link"
        :link="preHeader.link"
        class="pre-header"
    >
        <div class="pre-header-content">
            {{ preHeader.link.text }}
        </div>

        <div class="curtain"></div>
    </CmsLink>
</template>

<script setup lang="ts">
import { useMenus } from '@/plugins/menu'

import CmsLink from '@/components/cms/CmsLink.vue'

const { preHeader } = useMenus()
</script>

<style lang="scss" scoped>
.pre-header {
    background: $blue;
    color: $white;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    @include min-width(1024) {
        height: 50px;
    }

    .curtain {
        width: 100%;
        height: 100%;
        position: absolute;
        background: $white;
        opacity: 0;
        pointer-events: none;
    }

    .menu-open & {
        height: 0;
        overflow-y: hidden;
    }

    .pre-header-content {
        font-family: $effra-font-stack;
        font-size: 0.685rem;
        line-height: 1.45em;
        letter-spacing: 0.1em;
        text-align: center;
        text-transform: uppercase;
        max-width: 360px;
        padding: 0 10px;

        @include min-width(768) {
            max-width: initial;
        }

        @include min-width(1024) {
            font-size: 12px;
        }

        &::after {
            font-family: $icon-font;
            content: $icon-angle-right;
            font-weight: 700;
            display: inline-block;
            margin: 0 0 0 5px;
            font-size: 0.5rem;
        }
    }
}
</style>
